var React = require('react');

function PinAdd (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M51.6857 92.9092L49 95.2543L46.3143 92.9092C23.7295 73.1886 12.25 55.9693 12.25 40.8334C12.25 19.3986 28.9796 4.08337 49 4.08337C69.0204 4.08337 85.75 19.3986 85.75 40.8334C85.75 55.9693 74.2705 73.1886 51.6857 92.9092ZM20.4167 40.8334C20.4167 52.4677 29.8353 67.1037 49 84.3756C68.1647 67.1037 77.5833 52.4677 77.5833 40.8334C77.5833 24.0778 64.6632 12.25 49 12.25C33.3368 12.25 20.4167 24.0778 20.4167 40.8334ZM44.9167 24.5V36.75H32.6667V44.9167H44.9167V57.1667H53.0833V44.9167H65.3333V36.75H53.0833V24.5H44.9167Z","fill":"#056839"}));
}

PinAdd.defaultProps = {"width":"98","height":"98","viewBox":"0 0 98 98","fill":"none"};

module.exports = PinAdd;

PinAdd.default = PinAdd;
